import { put, call } from 'redux-saga/effects';
import { authenticateUser } from 'auth/sagas';
import { setRedirect } from 'auth/actions';
import { sprintAddData, bypassedAddData } from 'app/routes';

export function* sprintAddDataNavigate({ subId }) {
  yield put(setRedirect(sprintAddData(subId)));
  yield call(authenticateUser);
}

export function* bypassedAddDataNavigate({ subId }) {
  yield put(setRedirect(bypassedAddData(subId)));
  yield call(authenticateUser);
}
